import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacebookPagesLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M26 14.6838C26 7.67874 20.4036 2 13.5 2C6.59644 2 1 7.67874 1 14.6838C1 21.0147 5.57106 26.262 11.5469 27.2136V18.3502H8.37305V14.6838H11.5469V11.8894C11.5469 8.71053 13.413 6.95463 16.2683 6.95463C17.6359 6.95463 19.0664 7.20235 19.0664 7.20235V10.3238H17.4902C15.9374 10.3238 15.4531 11.3015 15.4531 12.3046V14.6838H18.9199L18.3657 18.3502H15.4531V27.2136C21.4289 26.262 26 21.0147 26 14.6838Z",
		fill: "#1877F2"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.3657 18.3527L18.9199 14.6862H15.4531V12.3069C15.4531 11.3039 15.9374 10.3262 17.4902 10.3262H19.0664V7.20476C19.0664 7.20476 17.6359 6.95703 16.2683 6.95703C13.413 6.95703 11.5469 8.71294 11.5469 11.8918V14.6862H8.37305V18.3527H11.5469V27.216C12.193 27.3187 12.846 27.3702 13.5 27.3701C14.1645 27.3701 14.8167 27.3173 15.4531 27.216V18.3527H18.3657Z",
		fill: "white"
	})]
});
export default SvgFacebookPagesLogo;
